import "./src/scss/main.scss"

import React from "react";
import { ParallaxProvider } from "react-scroll-parallax";
import "@fontsource/exo-2";

export const wrapPageElement = ({ element, props }) => {
  return <ParallaxProvider>{element}</ParallaxProvider>
};